// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as PromotionRoutes from "./PromotionRoutes.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as Notifier__Context from "../../bundles/Notifier/Notifier__Context.res.js";
import * as PromotionEditPage from "./PromotionEditPage.res.js";
import * as PromotionListPage from "./PromotionListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function PromotionRouter(props) {
  let url = Navigation.useUrl();
  let userRole = Auth.useRole();
  let authScope = Auth.useScope();
  let notifierContext = Notifier.createContext();
  let createRoute = PromotionRoutes.authorizedCreateRoute(authScope);
  let canShopKindEdit = Stdlib_Result.isOk(createRoute);
  if (!Auth.isAuthorizedAccess(userRole, PromotionRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  let match = Stdlib_List.fromArray(url.path);
  let tmp;
  let exit = 0;
  if (match !== 0 && match.hd === "promotions") {
    let match$1 = match.tl;
    if (match$1 !== 0) {
      let cku = match$1.hd;
      let exit$1 = 0;
      if (cku === "create") {
        if (match$1.tl !== 0) {
          exit = 1;
        } else if (canShopKindEdit) {
          tmp = JsxRuntime.jsx(PromotionEditPage.make, {
            canShopKindEdit: canShopKindEdit
          });
        } else {
          exit$1 = 2;
        }
      } else {
        exit$1 = 2;
      }
      if (exit$1 === 2) {
        if (match$1.tl !== 0) {
          exit = 1;
        } else {
          tmp = JsxRuntime.jsx(PromotionEditPage.make, {
            cku: cku,
            canShopKindEdit: canShopKindEdit
          });
        }
      }
    } else {
      tmp = JsxRuntime.jsx(PromotionListPage.make, {
        authorizedCreateRoute: createRoute
      });
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Navigation.Redirect.make, {
      route: PromotionRoutes.baseRoute
    });
  }
  return JsxRuntime.jsx(Notifier__Context.Provider.make, {
    value: notifierContext,
    children: tmp
  });
}

let make = PromotionRouter;

export {
  make,
}
/* Auth Not a pure module */
